"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListingDetails = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _extend2 = _interopRequireDefault(require("lodash/extend"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _List = _interopRequireDefault(require("@concur/nui-widgets/lib/List/List"));
var _MessageStrip = _interopRequireDefault(require("@concur/nui-widgets/lib/MessageStrip/MessageStrip"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _reactRouterDom = require("react-router-dom");
var _config = _interopRequireDefault(require("../config"));
var _Carousel = _interopRequireDefault(require("./Carousel"));
var _LogoLinksAndDesc = _interopRequireDefault(require("./LogoLinksAndDesc"));
var _termsModule = require("../terms/termsModule");
var _AnalyticsModule = require("../analytics/modules/AnalyticsModule");
var _analytics = require("../constants/analytics");
var _terms = _interopRequireDefault(require("../terms"));
var _EnrollModal = _interopRequireDefault(require("./EnrollModal"));
var _UnenrollModal = _interopRequireDefault(require("./UnenrollModal"));
var _DisconnectModal = _interopRequireDefault(require("./DisconnectModal"));
var _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal"));
var _utils = require("../utils");
var _offeringTypes = _interopRequireDefault(require("../config/offeringTypes"));
var _regions = _interopRequireDefault(require("../config/regions"));
var _withAppContext = require("../HOCs/withAppContext");
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/listingDetails.css") : void 0;
var _withRouter = require("../HOCs/withRouter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ListingDetails = exports.ListingDetails = /*#__PURE__*/function (_React$Component) {
  function ListingDetails() {
    var _this;
    _classCallCheck(this, ListingDetails);
    _this = _callSuper(this, ListingDetails);
    _this.state = {
      detailsExpanded: false,
      regionsAreDisplayed: {}
    };
    _this._toggleDetails = _this._toggleDetails.bind(_this);
    _this._toggleDisplayedForRegion = _this._toggleDisplayedForRegion.bind(_this);
    _this.launchTandCinfoOnly = _this.launchTandCinfoOnly.bind(_this);
    _this.onConnectListingConnectClick = _this.onConnectListingConnectClick.bind(_this);
    return _this;
  }

  // connect button callback for "connect (COCPAP)" listings.
  // hence the redundant-looking function name
  _inherits(ListingDetails, _React$Component);
  return _createClass(ListingDetails, [{
    key: "onConnectListingConnectClick",
    value: function onConnectListingConnectClick() {
      var _this$props = this.props,
        _this$props$listing = _this$props.listing,
        ID = _this$props$listing.ID,
        _this$props$listing$c = _this$props$listing.core,
        flow = _this$props$listing$c.oAuthWorkflowType,
        listingName = _this$props$listing$c.listingName,
        v1ID = _this$props$listing$c.v1ID,
        CompanyUUID = _this$props.profile.CompanyUUID,
        trackButtonClick = _this$props.trackButtonClick,
        launchTermsAndConditionsModal = _this$props.launchTaCModal;
      _nuiLogger.default.info({
        description: "New connect button called for listing ".concat(ID),
        'cte.category': 'listing-detail-page',
        'cte.subcategory': 'connect-button-click'
      });
      trackButtonClick({
        elementPath: ["".concat(_analytics.listingConst, " ").concat(listingName), _analytics.button.connect],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: CompanyUUID
        }
      });
      launchTermsAndConditionsModal({
        tAndCLinkClicked: false,
        flow: flow,
        listingId: ID,
        v1ListingId: v1ID,
        needAnAccountClicked: false
      });
    }
  }, {
    key: "_toggleDetails",
    value: function _toggleDetails() {
      // if this ever needs to be re-used or gets ugly, we can consider:
      // https://github.com/craigambrose/react-more/blob/master/lib/index.js
      this.setState({
        detailsExpanded: !this.state.detailsExpanded
      });
    }
  }, {
    key: "_toggleDisplayedForRegion",
    value: function _toggleDisplayedForRegion(region) {
      // toggle region visibility only for a region, as a boolean value for the region key in the state
      var regionsAreDisplayed = (0, _extend2.default)({}, this.state.regionsAreDisplayed);
      regionsAreDisplayed[region] = region in regionsAreDisplayed ? !regionsAreDisplayed[region] : true;
      this.setState({
        regionsAreDisplayed: regionsAreDisplayed
      });
    }
  }, {
    key: "launchTandCinfoOnly",
    value: function launchTandCinfoOnly() {
      this.props.launchTaCModal({
        tAndCLinkClicked: true,
        listingId: this.props.listing.ID,
        v1ListingId: this.props.listing.core.v1ID
      });
    }
  }, {
    key: "renderDisabledWarning",
    value: function renderDisabledWarning() {
      var isDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var hasOfferings = arguments.length > 1 ? arguments[1] : undefined;
      var hasPod = arguments.length > 2 ? arguments[2] : undefined;
      var isAdminListing = arguments.length > 3 ? arguments[3] : undefined;
      if (isDisabled) {
        return /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "ListingDisabledByCompany",
          className: "cnqr-alert cnqr-alert-warning disabled-warning"
        });
      }
      if (!hasOfferings && !isAdminListing) {
        return /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "ListingNotCompatibleWithOfferings",
          className: "cnqr-alert cnqr-alert-warning disabled-warning"
        });
      }
      if (!hasPod && !isAdminListing) {
        return /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "ListingNotCompatibleWithPod",
          className: "cnqr-alert cnqr-alert-warning disabled-warning"
        });
      }
      return null;
    }
  }, {
    key: "renderOfferings",
    value: function renderOfferings() {
      var offerings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var formatter = arguments.length > 1 ? arguments[1] : undefined;
      return /*#__PURE__*/_react.default.createElement(_List.default, {
        label: formatter.formattedMessage({
          id: 'WorksWithTheseConcurOfferings'
        })
      }, offerings.map(function (offering) {
        return /*#__PURE__*/_react.default.createElement(_List.default.Item, null, _offeringTypes.default[offering]);
      }));
    }
  }, {
    key: "renderRegions",
    value: function renderRegions(regions, formatter) {
      var _this2 = this;
      var localizedRegionsAndCountries = [];
      if (this.props.localizedRegions && this.props.localizedCountries) {
        localizedRegionsAndCountries = Object.entries(regions).map(function (region) {
          var localizedRegionName = (0, _find2.default)(_this2.props.localizedRegions, function (localizedRegion) {
            return localizedRegion.code === _regions.default[region[0]];
          });
          var localizedCountries = [];
          region[1].map(function (countryCode) {
            var localizedCountryName = (0, _find2.default)(_this2.props.localizedCountries, function (localizedCountry) {
              return localizedCountry.code === countryCode;
            });
            return localizedCountries.push(localizedCountryName.description);
          });
          return {
            region: localizedRegionName.description,
            countries: localizedCountries
          };
        });
      }
      return /*#__PURE__*/_react.default.createElement(_List.default, {
        label: formatter.formattedMessage({
          id: 'RegionsAvailable'
        })
      }, localizedRegionsAndCountries.filter(function (region) {
        return region.countries.length !== 0;
      }).map(function (i) {
        return /*#__PURE__*/_react.default.createElement(_List.default.Group, {
          expandable: {
            localizedText: {
              textCollapse: formatter.formattedMessage({
                id: 'collapse'
              }),
              textExpand: formatter.formattedMessage({
                id: 'expand'
              })
            },
            isExpanded: false
          },
          label: i.region
        }, Object.values((0, _uniq2.default)(i.countries)).map(function (country) {
          return /*#__PURE__*/_react.default.createElement(_List.default.Item, null, country);
        }));
      }));
    }
  }, {
    key: "renderBackToAppCenter",
    value: function renderBackToAppCenter() {
      return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: (0, _utils.getAppCenterPathName)(this.props.location.pathname)
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "BackToAppCenter"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$profile,
        _this3 = this,
        _this$props3,
        _this$props3$errors,
        _this$props3$errors$I;
      var _this$props2 = this.props,
        listing = _this$props2.listing,
        _this$props2$offering = _this$props2.offerings,
        offerings = _this$props2$offering === void 0 ? [] : _this$props2$offering,
        pod = _this$props2.pod,
        formatter = _this$props2.formatter;
      var ID = listing.ID,
        _listing$core = listing.core,
        listingDisabled = _listing$core.listingDisabled,
        regions = _listing$core.regions,
        listingName = _listing$core.listingName,
        oAuthWorkflowType = _listing$core.oAuthWorkflowType,
        clientOptInType = _listing$core.clientOptInType,
        v1ID = _listing$core.v1ID,
        _listing$core$offerin = _listing$core.offerings,
        listingOfferings = _listing$core$offerin === void 0 ? [] : _listing$core$offerin,
        _listing$core$pods = _listing$core.pods,
        listingPods = _listing$core$pods === void 0 ? [] : _listing$core$pods,
        compatibleWithDataCenter = _listing$core.compatibleWithDataCenter,
        isTriplinkDisabledApp = _listing$core.isTriplinkDisabledApp,
        dnfCompleted = listing.dnfCompleted,
        dnfRequired = listing.dnfRequired;
      var _this$props$userPrefs = this.props.userPrefs,
        userId = _this$props$userPrefs.userId,
        isTestEntity = _this$props$userPrefs.isTestEntity;
      var hasOfferings = !userId || userId && offerings.filter(function (offering) {
        return listingOfferings.indexOf(offering) !== -1;
      }).length > 0; // eslint-disable-line max-len

      var hasPodNew = compatibleWithDataCenter;
      var hasPodOld = !userId || !pod && pod !== 0 || listingPods.indexOf((0, _utils.fixQAPodId)(pod)) !== -1;
      var hasPod = hasPodNew || hasPodOld;
      var isAdminListing = clientOptInType === 'ADMIN';

      // This indicates if the user is subject to potential listing connection blocking
      var blockIncompleteDnf = (_config.default.nui.forceIncompleteDnfConnectionBlocking || _config.default.nui.enableIncompleteDnfConnectionBlocking && ((_this$props$profile = this.props.profile) === null || _this$props$profile === void 0 ? void 0 : _this$props$profile.betas['dnf-consumer'])) && !isTestEntity;
      // This indicates if the listing connection is blocked due to incomplete dnf
      var isConnectionBlocked = blockIncompleteDnf && dnfRequired && !dnfCompleted;
      var areRegionsPopulated = function areRegionsPopulated() {
        if (regions.asia.length > 0 || regions.emea.length > 0 || regions.latinAmerica.length > 0 || regions.northAmerica.length > 0) {
          return true;
        }
        return false;
      };
      var onClose = function onClose(errorId) {
        return function () {
          _this3.props.clearError(ID, errorId);
        };
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "details-container",
        "data-testid": "listing-details"
      }, (_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : (_this$props3$errors = _this$props3.errors) === null || _this$props3$errors === void 0 ? void 0 : (_this$props3$errors$I = _this$props3$errors[ID]) === null || _this$props3$errors$I === void 0 ? void 0 : _this$props3$errors$I.map(function (error) {
        return /*#__PURE__*/_react.default.createElement(_MessageStrip.default, {
          typeLabel: formatter.formattedMessage({
            id: 'CoreUIComponents.error'
          }),
          key: error.componentId,
          message: error.errorMessage,
          type: "error",
          dismissible: {
            dismissLabel: 'close',
            onDismiss: onClose(error.componentId)
          }
        });
      }), (0, _utils.canUseDOM)() && /*#__PURE__*/_react.default.createElement(_EnrollModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), (0, _utils.canUseDOM)() && /*#__PURE__*/_react.default.createElement(_UnenrollModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), (0, _utils.canUseDOM)() && /*#__PURE__*/_react.default.createElement(_DisconnectModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), /*#__PURE__*/_react.default.createElement(_ConfirmationModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "row standard-font"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12",
        style: {
          float: 'none'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 back-link-row"
      }, this.renderBackToAppCenter(ID, listingName, this.props.category), this.renderDisabledWarning(listingDisabled || isTriplinkDisabledApp, hasOfferings, hasPod, isAdminListing))), isConnectionBlocked && !listingDisabled && /*#__PURE__*/_react.default.createElement("div", {
        className: "row",
        style: {
          marginBottom: '24px'
        }
      }, /*#__PURE__*/_react.default.createElement(_MessageStrip.default, {
        typeLabel: formatter.formattedMessage({
          id: 'CoreUIComponents.warning'
        }),
        message: formatter.formattedMessage({
          id: 'AppCenterV2.listing.dnfExplanation'
        }),
        type: "warning"
      })), /*#__PURE__*/_react.default.createElement(_LogoLinksAndDesc.default, {
        listing: listing,
        toggleDetails: this._toggleDetails,
        betas: this.props.betas,
        detailsExpanded: this.state.detailsExpanded,
        listingDisabled: listingDisabled || (!hasOfferings || !hasPod) && !isAdminListing,
        onConnectListingConnectClick: this.onConnectListingConnectClick
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-12 details-lower-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 margin-top-lg"
      }, this.props.listing.core.webScreenshots && this.props.listing.core.webScreenshots.length ? /*#__PURE__*/_react.default.createElement(_Carousel.default, {
        images: this.props.listing.core.webScreenshots
      }) : null)), listing.core && listing.core.offerings.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-9 margin-top-lg"
      }, listing.core && this.renderOfferings(listing.core.offerings, formatter))), listing.core && areRegionsPopulated() && /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-9 margin-top-lg",
        style: {
          marginBottom: !userId && '16px'
        }
      }, listing.core && regions && this.renderRegions(regions, formatter))), userId && /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-6 margin-top-lg"
      }, /*#__PURE__*/_react.default.createElement("h4", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        className: "ac-details-link",
        id: "ac-terms-link",
        onClick: this.launchTandCinfoOnly
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "TermsTitle"
      }))), (0, _utils.canUseDOM)() ? /*#__PURE__*/_react.default.createElement(_terms.default, {
        listingId: ID,
        v1ListingId: v1ID,
        publisher: this.props.listing.localized.publisher,
        flow: oAuthWorkflowType,
        clientOptInType: this.props.listing.core.clientOptInType
      }) : ''))))));
    }
  }]);
}(_react.default.Component);
ListingDetails.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string,
    core: _propTypes.default.object,
    images: _propTypes.default.object,
    localized: _propTypes.default.object,
    loyaltyNumber: _propTypes.default.string,
    v1Data: _propTypes.default.object
  }).isRequired,
  launchTaCModal: _propTypes.default.func.isRequired,
  localizedRegions: _propTypes.default.array,
  localizedCountries: _propTypes.default.array,
  userPrefs: _propTypes.default.shape({
    userId: _propTypes.default.string,
    isTestEntity: _propTypes.default.bool
  }),
  location: _propTypes.default.object,
  formatter: _propTypes.default.shape({
    formattedMessage: _propTypes.default.func.isRequired
  }).isRequired,
  trackButtonClick: _propTypes.default.func.isRequired,
  profile: _propTypes.default.shape({
    CompanyUUID: _propTypes.default.string.isRequired
  })
};
function mapStateToProps(state) {
  var _state$userProfile;
  return {
    betas: state.betas || {},
    profile: (_state$userProfile = state.userProfile) === null || _state$userProfile === void 0 ? void 0 : _state$userProfile.profile
  };
}
var _default = exports.default = (0, _withRouter.withRouter)((0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, {
  launchTaCModal: _termsModule.launchTaCModal,
  trackButtonClick: _AnalyticsModule.buttonClickDispatch
})((0, _nuiIntlRuntime.withFormatter)(ListingDetails))));